(() => {
  if (window.__paymentAssignTurboInit) return;
  window.__paymentAssignTurboInit = true;

  document.addEventListener('turbo:before-stream-render', (event) => {
    const stream = event.target;
    if (!(stream instanceof Element) || stream.getAttribute('target') !== 'modal_placeholder') return;

    const originalRender = event.detail.render;
    event.detail.render = (currentElement, newElement) => {
      originalRender(currentElement, newElement);

      const modalElement = document.getElementById('payment_assign_modal');
      if (!modalElement) return;

      const placeholder = $('#modal_placeholder');
      modalElement.addEventListener('hidden.bs.modal', () => {
        placeholder.empty();
      }, { once: true });

      const bsModal = window.bootstrap?.Modal?.getOrCreateInstance(modalElement);
      bsModal?.show();
    };
  });
})();
